
(function fileDetailControllerDefinition() {
    'use strict';

    angular.module('File')
        .controller('FileDetailController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'fileService',
            function fileDetailController($scope, config, $state, $translate, $stateParams, errors, fileService) {

                $scope.cancel = function () {
                    //stateFileToComeBack         
                    $state.go('document-detail', { id: $stateParams.id });
                };

                $scope.load = function () {
                    fileService.getById($stateParams.id).then(function (result) {
                        $scope.content = 'data:application/pdf;base64,' + result.value.base64File;

                        $scope.file = result;

                        $translate(['FileDetail']).then(function (translated) {
                            $scope.title = translated.FileDetail + $scope.file.name;
                        });
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                        $scope.cancel();
                    });
                }

                $scope.load();

            }
        ]);
})();